<div class="nav-font14">
  <div class="grey6 font-weight-bold">Parameter mapping</div>
  <div class="grey4 nav-font12 mb-2">
    Pass a vendor parameter to the survey link under another name, for example s2 as session_id.
  </div>

  @if (mappings.length > 0) {
  <!-- Invisible icons keep the headers over their inputs -->
  <div class="d-flex grey6 nav-font12 font-weight-bold mb-1" aria-hidden="true">
    <span class="flex-fill w-50">Vendor sends</span>
    <i class="fas fa-arrow-right mx-2 invisible"></i>
    <span class="flex-fill w-50">Survey receives</span>
    <i class="far fa-trash-can ml-2 invisible"></i>
  </div>
  }

  @for (mapping of mappings; track $index; let i = $index) {
  <div class="d-flex align-items-center mb-1">
    <input type="text" class="form-control form-control-sm form-control-nav flex-fill w-50" placeholder="e.g. s2"
      [attr.aria-label]="'Vendor sends, row ' + (i + 1)" [class.is-invalid]="errors[i]"
      [ngModel]="mapping.vendorParam" (ngModelChange)="updateMapping(i, 'vendorParam', $event)">
    <i class="fas fa-arrow-right grey4 mx-2" aria-hidden="true"></i>
    <input type="text" class="form-control form-control-sm form-control-nav flex-fill w-50" placeholder="e.g. session_id"
      [attr.aria-label]="'Survey receives, row ' + (i + 1)" [class.is-invalid]="errors[i]"
      [ngModel]="mapping.surveyParam" (ngModelChange)="updateMapping(i, 'surveyParam', $event)">
    <button type="button" class="bg-transparent border-0 ml-2 p-0" [attr.aria-label]="'Remove mapping, row ' + (i + 1)"
      (click)="removeMapping(i)">
      <i class="far fa-trash-can grey4" aria-hidden="true"></i>
    </button>
  </div>
  @if (errors[i]) {
  <div class="text-danger nav-font12 mb-1">{{ errors[i] }}</div>
  }
  }

  <div class="d-flex flex-wrap align-items-center mt-2">
    <button type="button" class="btn btn-sm btn-link p-0 shadow-none nav-font14" (click)="addMapping()">
      <i class="fas fa-plus mr-1" aria-hidden="true"></i>Add mapping
    </button>
    @if (suggestions.length > 0) {
    <span class="grey4 nav-font12 ml-3 mr-1">Quick add:</span>
    @for (name of suggestions; track name) {
    <button type="button" class="btn btn-sm nav-btn-primary shadow-none nav-font12 py-0 ml-1" (click)="addMapping(name)">+ {{ name }}</button>
    }
    }
  </div>

  <div class="mt-4">
    <label class="grey6 font-weight-bold mb-1" [for]="idPrefix + '-ending'">Fixed parameters</label>
    <input type="text" class="form-control form-control-sm form-control-nav" [id]="idPrefix + '-ending'"
      [ngModel]="landingLinkEnding" (ngModelChange)="onEndingChange($event)"
      [attr.aria-describedby]="idPrefix + '-ending-help' + (endingClashes.length > 0 ? ' ' + idPrefix + '-ending-clash' : '')">
    @if (endingClashes.length > 0) {
    <div class="text-warning nav-font12 mt-1" [id]="idPrefix + '-ending-clash'" role="status">
      <i class="fas fa-triangle-exclamation mr-1" aria-hidden="true"></i>
      {{ endingClashes.join(', ') }} {{ endingClashes.length === 1 ? 'is' : 'are' }} also on the vendor entry link or
      mapped to the survey. The value here will overwrite it on the survey link and in data exports.
    </div>
    }
    <div class="grey4 nav-font12 mt-1" [id]="idPrefix + '-ending-help'">
      Added to the survey link for this vendor's respondents only, for example or3=2. The vendor never sees them.
    </div>
  </div>

  <div class="bg-light rounded mt-4 p-3">
    <div class="grey6 font-weight-bold mb-2">Preview</div>
    <div class="grey4 nav-font12">Vendor entry link</div>
    <div class="d-flex align-items-start mb-2">
      @if (canCopyEntryUrl) {
      <button type="button" class="bg-transparent border-0 mr-2 p-0" aria-label="Copy vendor entry link"
        tooltip="Copy to clipboard" (click)="copyEntryUrl()">
        <i class="far fa-copy grey4" aria-hidden="true"></i>
      </button>
      }
      <div class="nav-black2 nav-font12 text-break">{{ previewEntryUrl }}</div>
    </div>
    <div class="grey4 nav-font12">
      Respondent lands on (sample values{{ surveyLink ? '' : ', example survey link' }}). Parameters set here are in bold.
    </div>
    <!-- One line: whitespace between the runs would show as spaces in the link -->
    <div class="nav-black2 nav-font12 text-break">@for (part of previewSurveyParts; track $index) {<span [class.font-weight-bold]="part.setHere" [class.nav-secondary]="part.setHere">{{ part.text }}</span>}</div>
  </div>
</div>
